module.exports = __webpack_public_path__ + "img/TECHNOLOGY-JIMNY-2.8e863962.jpg";